const BLOCK_TAGS = new Set([
  'ADDRESS',
  'ARTICLE',
  'BLOCKQUOTE',
  'DIV',
  'DL',
  'DT',
  'DD',
  'FIGCAPTION',
  'FIGURE',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'HR',
  'LI',
  'OL',
  'P',
  'PRE',
  'SECTION',
  'TABLE',
  'TD',
  'TH',
  'TR',
  'UL',
]);

export const normalizeFindText = (text: string) =>
  text.replace(/\s+/g, ' ').trim();

type TextPosition = { node: Text; offset: number };

// Use the same whitespace and block boundaries for indexing and DOM ranges
export function readFindText(root: Node, includePositions = false) {
  let text = '';
  const positions: TextPosition[] = [];
  const append = (value: string, node?: Text) => {
    for (let offset = 0; offset < value.length; offset++) {
      const character = /\s/.test(value[offset]) ? ' ' : value[offset];
      if (character === ' ' && (!text || text.endsWith(' '))) continue;
      text += character;
      if (includePositions) {
        positions.push(
          node ? { node, offset } : positions[positions.length - 1]
        );
      }
    }
  };
  const visit = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      append(node.textContent ?? '', node as Text);
      return;
    }
    const element = node instanceof Element ? node : null;
    if (
      element &&
      (element.matches(
        'script, style, template, noscript, iframe, object, embed, [hidden], [aria-hidden="true"], [data-find-exclude], [data-find-field-exclude]'
      ) ||
        (element instanceof HTMLElement &&
          (element.style.display === 'none' ||
            element.style.visibility === 'hidden')))
    )
      return;
    const boundary =
      element && (BLOCK_TAGS.has(element.tagName) || element.tagName === 'BR');
    if (boundary) append(' ');
    node.childNodes.forEach(visit);
    if (boundary) append(' ');
  };
  visit(root);
  return { text: text.trimEnd(), positions };
}
